import * as Item from '/src/ejs/component/component-slider-item.ejs';
import {CustomEventHandler} from "../../utils/CustomEventHandler";
import {CUSTOM_SCROLL, isMobile} from "../../common/globalVars";
import {MathUtil} from "../../utils/MathUtil";
import MobileSlider from "./mobile-slider";
import SiteData from "../../../../setting/site-data";
import {HtmlUtil} from "../../utils/HtmlUtil";

export default class ProductSlider {
    constructor(el, data) {
        this.el = el;
        this.data = data;
        this.height = 0;
        this.width = 0;
        this.itemWidth = 0;

        this.alignRight = this.el.classList.contains('right');

        this.container = el.querySelector('.slider-container');
        this.init();
    }

    init() {
        this.setContainer();
        this.mobileSlider = new MobileSlider(this.el);
        this.addEvent();
    }

    setContainer() {
        if (SiteData.isHtmlTest) return;
        // 좌측으로 overflow hidden 설정
        this.el.querySelector('content').style.overflow = 'hidden';
        this.container.innerHTML = '';
        ejs.delimiter = '$';

        let cnt = 1;

        this.data.forEach(
            (data)=>{
                data.current = cnt++;
                data.total = this.data.length;
                let element = HtmlUtil.getEjsElement(Item(), data);
                this.container.appendChild(element);
            }
        )
    }

    addEvent() {
        this.onResizeHandler();
        CustomEventHandler.addHandler(window, 'resize', ()=>this.onResizeHandler());
        CustomEventHandler.addHandler(window, CUSTOM_SCROLL, (e)=>this.onScrollHandler(e));
    }

    setSize() {
        let tmpHeight = 0;
        let tmpWidth = 0;
        let itemEls = this.container.querySelectorAll('li');

        itemEls.forEach((item)=>{
            if (tmpHeight < item.getBoundingClientRect().height) {
                tmpHeight = item.getBoundingClientRect().height;
            }
            this.itemWidth =item.getBoundingClientRect().width
            tmpWidth += this.itemWidth;
        });

        this.container.style.height = tmpHeight + 'px';
        this.height = tmpHeight;
        this.width = tmpWidth;
        // this.maxWidthX = this.el.querySelector('content').getBoundingClientRect().width - this.width - this.itemWidth;
        let contentWidth = this.el.querySelector('content').getBoundingClientRect().width;
        // this.maxWidthX = contentWidth - this.width;
        this.maxWidthX = contentWidth - this.width ;

        if (this.alignRight) {
            if (this.maxWidthX > 0) {
                let x = (this.itemWidth * 4) - (itemEls.length * this.itemWidth);
                this.container.style.transform = `translate3d( ${x}px, 0, 0)`;
            }
        }
    }

    onResizeHandler() {
        this.setSize();
    }

    onScrollHandler(e) {
        if(isMobile(window.innerWidth)) {
            this.mobileSlider.setEnable();
        } else {
            this.mobileSlider.setDisable();
            let velocity = e.detail - this.el.offsetTop + window.innerHeight -this.height -200;
            // console.log(velocity);
            // 0 : window.innerHeight - this.height = 0 : this.width*-1;
            if (this.maxWidthX < 0) {
                let tX = MathUtil.lerp(0, this.maxWidthX, velocity / (window.innerHeight - this.height - document.querySelector('header').getBoundingClientRect().height  - 200));
                //- document.querySelector('header').getBoundingClientRect().height)
                tX = MathUtil.clamp(tX, 0, this.maxWidthX);
                this.container.style.transform = `translate3d( ${tX}px, 0, 0)`;
            } else {
                this.container.style.transform = `translate3d( 0, 0, 0)`;
            }
        }
    }
}
